import client from './client';

export const onboardingApi = {
  // Derived from live data on every call — this is what makes the checklist
  // tick itself off while the user works.
  status: () => client.get('/onboarding/status').then((r) => r.data),
  dismiss: (payload) => client.post('/onboarding/dismiss', payload || {}).then((r) => r.data),
};

export default onboardingApi;
